import ConsultingIcon from '../../icons/ConsultingIcon/ConsultingIcon.svg';
import CreateIcon from '../../icons/CreateIcon/CreateIcon.svg';
import CareIcon from '../../icons/CareIcon/CareIcon.svg';
import MeatingIcon from '../../icons/MeatingIcon/MeatingIcon.svg';
import PresentationIcon from '../../icons/PresentationIcon/PresentationIcon.svg';
import SignIcon from '../../icons/SignIcon/SignIcon.svg';
import BuildingIcon from '../../icons/BuildingIcon/BuildingIcon.svg';

const loansData = [
  {
    id: '1',
    title: 'Schůzka',
    text: 'Vysvětlení principů spolupráce s JHavel Finance, zjištění potřeb klienta.',
    icon: MeatingIcon,
  },
  {
    id: '2',
    title: 'Projednání záměru',
    text: 'Projednání a následné stanovení základních parametrů, jako je výše úvěru, splatnost, délka fixace úrokové sazby, období čerpání atd.',
    icon: ConsultingIcon,
  },
  {
    id: '3',
    title: 'Pověření JHavel Finance',
    text: 'Pověření JHavel Finance k zajištění nabídek od jednotlivých institucí.',
    icon: SignIcon,
  },
  {
    id: '4',
    title: 'Příprava nabídek',
    text: 'Příprava nabídek od všech institucí dle stanovených parametrů, úprava dle požadavků klienta.',
    icon: CreateIcon,
  },
  {
    id: '5',
    title: 'Vyhodnocení a doporučení nabídek',
    text: 'Předání všech finálních nabídek a doporučení ze strany JHavel Finance.',
    icon: PresentationIcon,
  },
  {
    id: '6',
    title: 'Podpis smluv',
    text: 'Zajištění podpisů smluv s financující institucí.',
    icon: SignIcon,
  },
  {
    id: '7',
    title: 'Péče v období čerpání úvěru',
    text: 'Komplexní péče spočívající v kontrole a předání dokumentů od klienta financující instituci, případné poradenství.',
    icon: CareIcon,
  },
  {
    id: '8',
    title: 'Dokončená rekonstrukce',
    text: 'Zajištění předání protokolů o předání díla a ukončení čerpání úvěru. ',
    icon: BuildingIcon,
  },
  {
    id: '9',
    title: 'Péče v období splácení úvěru',
    text: 'Průběžná péče o klienta a kontrola parametrů úvěru vůči trhu, případné doporučení k refinancování úvěru.',
    icon: CareIcon,
  },
];

export default loansData;
